module.exports = __webpack_public_path__ + "static/media/puzzleIcon--active.d6c57300.svg";